import { createContext, useContext } from "react";

type HeroBackgroundContextValue = {
  /** Registers (or clears) the element the dark hero background must reach down to. */
  setHeroElement: (element: HTMLElement | null) => void;
};

/**
 * Lets a page tell AuthenticatedLayout how far its dark hero background should extend. The layout
 * owns the background image; the page owns the content that must sit on it (balance, payment
 * actions, stories). Without a registered element the background keeps its default height.
 */
export const HeroBackgroundContext =
  createContext<HeroBackgroundContextValue | null>(null);

export const useHeroBackground = () => useContext(HeroBackgroundContext);
